// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  backdrop-filter: blur(2px);
}

.confirm-dialog {
  position: fixed; /* viewport coordinates — see the positioning note in ConfirmDialog.js */
  background-color: var(--color-bg-card, #1e1e1e);
  border: 2px solid var(--wylie-purple, #50076d);
  border-radius: 8px;
  padding: 24px;
  min-width: 300px;
  max-width: 500px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  z-index: 9999;
  animation: slideIn 0.2s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.confirm-message {
  color: var(--color-text-light, #e5e7eb);
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 20px;
  white-space: pre-line;
}

.confirm-comment {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 20px;
}

.confirm-comment label {
  color: var(--color-text-muted, #999);
  font-size: 13px;
}

.confirm-comment textarea {
  width: 100%;
  padding: 8px 10px;
  background-color: var(--color-bg-input, #1e1e1e);
  color: var(--color-text-light, #e5e7eb);
  border: 1px solid var(--color-border, #444);
  border-radius: 5px;
  font: inherit;
  font-size: 14px;
  resize: vertical;
}

.confirm-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.btn-cancel,
.btn-confirm {
  padding: 10px 20px;
  background-color: transparent;
  border: 1px solid var(--btn-color);
  border-radius: 5px;
  color: var(--btn-color);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

/* Outlined like App.css's buttons: grey Cancel, purple Confirm. */
.btn-cancel {
  --btn-color: #adb5bd;
}

.btn-cancel:hover {
  background-color: var(--btn-color);
  color: #1f1f1f;
}

.btn-cancel:focus {
  outline: 2px solid var(--btn-color);
  outline-offset: 2px;
}

.btn-confirm {
  --btn-color: var(--part5-color);
}

.btn-confirm:hover {
  background-color: var(--btn-color);
  color: white;
}

.btn-confirm:focus {
  outline: 2px solid var(--btn-color);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ConfirmDialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,eAAe,EAAE,wEAAwE;EACzF,+CAA+C;EAC/C,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gDAAgD;EAChD,uCAAuC;EACvC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB","sourcesContent":[".confirm-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9998;\n  backdrop-filter: blur(2px);\n}\n\n.confirm-dialog {\n  position: fixed; /* viewport coordinates — see the positioning note in ConfirmDialog.js */\n  background-color: var(--color-bg-card, #1e1e1e);\n  border: 2px solid var(--wylie-purple, #50076d);\n  border-radius: 8px;\n  padding: 24px;\n  min-width: 300px;\n  max-width: 500px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  z-index: 9999;\n  animation: slideIn 0.2s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.confirm-message {\n  color: var(--color-text-light, #e5e7eb);\n  font-size: 15px;\n  line-height: 1.6;\n  margin-bottom: 20px;\n  white-space: pre-line;\n}\n\n.confirm-comment {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 20px;\n}\n\n.confirm-comment label {\n  color: var(--color-text-muted, #999);\n  font-size: 13px;\n}\n\n.confirm-comment textarea {\n  width: 100%;\n  padding: 8px 10px;\n  background-color: var(--color-bg-input, #1e1e1e);\n  color: var(--color-text-light, #e5e7eb);\n  border: 1px solid var(--color-border, #444);\n  border-radius: 5px;\n  font: inherit;\n  font-size: 14px;\n  resize: vertical;\n}\n\n.confirm-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.btn-cancel,\n.btn-confirm {\n  padding: 10px 20px;\n  background-color: transparent;\n  border: 1px solid var(--btn-color);\n  border-radius: 5px;\n  color: var(--btn-color);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n/* Outlined like App.css's buttons: grey Cancel, purple Confirm. */\n.btn-cancel {\n  --btn-color: #adb5bd;\n}\n\n.btn-cancel:hover {\n  background-color: var(--btn-color);\n  color: #1f1f1f;\n}\n\n.btn-cancel:focus {\n  outline: 2px solid var(--btn-color);\n  outline-offset: 2px;\n}\n\n.btn-confirm {\n  --btn-color: var(--part5-color);\n}\n\n.btn-confirm:hover {\n  background-color: var(--btn-color);\n  color: white;\n}\n\n.btn-confirm:focus {\n  outline: 2px solid var(--btn-color);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
